import { Elm } from "./Main.elm";
import ball0 from "./assets/balls/poolballs0.png";
import ball1 from "./assets/balls/poolballs1.png";
import ball2 from "./assets/balls/poolballs2.png";
import ball3 from "./assets/balls/poolballs3.png";
import ball4 from "./assets/balls/poolballs4.png";
import ball5 from "./assets/balls/poolballs5.png";
import ball6 from "./assets/balls/poolballs6.png";
import ball7 from "./assets/balls/poolballs7.png";
import ball8 from "./assets/balls/poolballs8.png";
import ball9 from "./assets/balls/poolballs9.png";
import ball10 from "./assets/balls/poolballs10.png";
import ball11 from "./assets/balls/poolballs11.png";
import ball12 from "./assets/balls/poolballs12.png";
import ball13 from "./assets/balls/poolballs13.png";
import ball14 from "./assets/balls/poolballs14.png";
import ball15 from "./assets/balls/poolballs15.png";

// Im Production-Build sind die Default-Imports fertige URL-Strings.
// Im Dev-Build (CJS, weil Elm CJS kompiliert) liefert Parcel für Asset-Module
// leere Stubs – die echten (gehashten) URLs stehen dann im importmap des
// index.html. Deshalb: String nutzen, sonst aus dem importmap nachschlagen.
const importedUrls = [
  ball0, ball1, ball2, ball3, ball4, ball5, ball6, ball7, ball8,
  ball9, ball10, ball11, ball12, ball13, ball14, ball15
];

function devTextureUrl(index) {
  const el = document.querySelector('script[type="importmap"]');
  if (!el) return null;
  try {
    const map = JSON.parse(el.textContent).imports || {};
    for (const url of Object.values(map)) {
      const m = String(url).match(/poolballs(\d+)\.[a-zA-Z0-9]+\.png$/);
      if (m && parseInt(m[1], 10) === index) return url;
    }
  } catch (e) {
    // importmap nicht lesbar – Fallback-Farbe im Rendering greift
  }
  return null;
}

const textureUrls = importedUrls.map((u, i) => {
  if (typeof u === "string") return u;
  const devUrl = devTextureUrl(i);
  // "" verhindert einen Elm-Flag-Crash – der Load schlägt dann einfach fehl
  // und die Kugel bleibt in der Fallback-Farbe.
  return devUrl || "";
});

// Get the actual window dimensions
const flags = {
  windowWidth: window.innerWidth,
  windowHeight: window.innerHeight,
  // Kugel-UV-Maps (index = Kugelnummer, 0 = weiße Kugel)
  textureUrls: textureUrls
};

// Browser.document benötigt keinen DOM-Knoten – init() liefert das Dokument
// (Title + Body), das Elm selbst rendert.
Elm.Main.init({
  flags: flags
});
